<template>
  <div class="swp_main">
    <div class="swp_item_main" :style="imgPost.list[index]"
      v-for="(item, index) in datas.list" :key="index"
      @click="onItem(item, index)">
      <div>
        <img class="swp_bg" :src="item.img" alt="">
        <div class="swp_item_text" :style="itemTextStyle">
          <div class="swp_item_t1">{{item.title}}</div>
          <div class="swp_item_t1">{{item.titleSub}}</div>
          <div class="swp_item_t2">{{item.tipe}}</div>
        </div>
        <!--<img class="swp_item_img" :style="itemImgStyle" :src="datas.textImg" alt="">-->
      </div>
    </div>
    <img class="swp_bg" :src="backImg" alt="">
    <img class="swp_fg" :src="forgImg" alt="">
    <div class="swp_dots" :style="dotStyle">
      <span v-for="(item, index) in datas.list" :key="index">
        <img class="swp_dot" v-show="nowN != index" src="@/assets/mobile/swiper_dot_ox.png" alt="">
        <img class="swp_dot" v-show="nowN == index" src="@/assets/mobile/swiper_dot_on.png" alt="">
      </span>

      <span style="padding: 0.2rem"></span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Swiper',
  components: {
  },
  props: [
    'datas', 'opts'
  ],
  data: () => {
    return {
      nowN: 0,
      // 是否继续计时
      isGo: true,

      // 每个图片的当前位置，修改当前位置来实现动画
      imgPost: {
        list: []
      }
    }
  },
  created () {
    // 切换动画时间
    const transition = this.datas.space
    let tleft = 0
    let tright = 0
    for (let index = 0; index < this.imgNum; index++) {
      this.imgPost.list.push({
        transition: transition,
        left: tleft + '%',
        right: tright + '%',
        zIndex: 1010
      })
      tleft += 100
      tright += -100
    }

    // 开始计时
    if (this.imgNum > 1) {
      this.goTime()
    }
  },
  mounted () {
    // console.log('mounted')
    this.isGo = true
  },
  activated () {
    // console.log('activated')
  },
  deactivated () {
    // console.log('deactivated')
  },
  beforeDestroy () {
    // console.log('beforeDestroy')
    this.isGo = false
  },
  methods: {
    goTime () {
      const self = this
      setTimeout(() => {
        if (self.isGo) {
          self.addNowN()
          self.goTime()
          if (self.imgNum > 2) {
            self.toSwiper()
          } else {
            self.toSwiper2()
          }
        }
      }, this.datas.time)
    },
    toSwiper () {
      // console.log('fffffffffffff')
      for (let index = 0; index < this.imgNum; index++) {
        const tleft = parseInt(this.imgPost.list[index].left)
        const tright = parseInt(this.imgPost.list[index].right)
        if (tleft < 0) {
          this.imgPost.list[index].left = ((this.imgNum - 2) * 100) + '%'
          this.imgPost.list[index].right = (-(this.imgNum - 2) * 100) + '%'
        } else {
          this.imgPost.list[index].left = (tleft - 100) + '%'
          this.imgPost.list[index].right = (tright + 100) + '%'
        }
        // 回移的放下面
        if (tleft <= 0) {
          this.imgPost.list[index].zIndex = 1005
        } else {
          this.imgPost.list[index].zIndex = 1010
        }
      }
    },
    goBack () {
      const self = this
      setTimeout(() => {
        // console.log('xxxx')
        for (let index = 0; index < self.imgNum; index++) {
          const tleft = parseInt(self.imgPost.list[index].left)
          if (tleft < 0) {
            self.imgPost.list[index].left = 100 + '%'
            self.imgPost.list[index].right = -100 + '%'
            self.imgPost.list[index].zIndex = 1005
          }
        }
      }, this.datas.time / 2)
    },
    toSwiper2 () {
      // console.log('fffffffffffff')
      for (let index = 0; index < this.imgNum; index++) {
        const tleft = parseInt(this.imgPost.list[index].left)
        const tright = parseInt(this.imgPost.list[index].right)
        this.imgPost.list[index].left = (tleft - 100) + '%'
        this.imgPost.list[index].right = (tright + 100) + '%'
        // 回移的放下面
        if (tleft <= 0) {
          this.imgPost.list[index].zIndex = 1005
        } else {
          this.imgPost.list[index].zIndex = 1010
        }
      }
      // 两个的时候要提前移动回去
      this.goBack()
    },
    addNowN () {
      this.nowN++
      if (this.nowN >= this.imgNum) {
        this.nowN = 0
      }
    },
    onItem (vitem, vid) {
      this.$emit('events', 'clickItem', vitem, vid)
    }
  },
  computed: {
    // 背景图，放个小点的文件，作为基础组件大小用
    backImg () {
      return this.datas.backgroundSizeImg
    },
    forgImg () {
      return this.datas.foregroundSizeImg
    },
    // 总数量
    imgNum () {
      return this.datas.list.length
    },
    dotStyle () {
      return this.datas.dotStyles
    },
    itemTextStyle () {
      return this.datas.textStyles
    },
    itemImgStyle () {
      return this.datas.textImgStyles
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swp_main {
  background: #fff;
  position: relative;
  overflow: hidden;
}
.swp_bg {
  width: 100%;
  z-index: 1000;
}
.swp_item_main {
  position: absolute;
  top: 0px;
  z-index: 1010;
}
.swp_fg {
  position: absolute;
  left: 0;
  top: 4px;
  width: 100%;
  pointer-events: none;
  z-index: 1020;
}
.swp_dots {
  position: absolute;
  width: 100%;
  text-align: right;
  z-index: 1050;
}
.swp_dot {
  height: 0.8rem;
  margin-right: 0.3rem;
}
.swp_item_text {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.4) , rgba(0, 0, 0, 0));
  position: absolute;
  left: 1.2rem;
  border-radius: 0.3rem;
  font-family: 微软雅黑;
  text-align: left;
  padding: 0.5rem;
  padding-right: 10%;
  width: 55%;
  color: #fff;
}
.swp_item_t1 {
  font-size: 1rem;
  line-height: 1.6rem;
  font-weight:900;
}
.swp_item_t2 {
  font-size: 0.8rem;
  color: #eee;
}
.swp_item_img {
  position: absolute;
  left: 1.2rem;
  cursor: pointer;
}
</style>
